module.exports = __webpack_public_path__ + "img/partner-agents.639cc562.png";